<template>
    <div id="register-member-second">
        <div id="header">
            <img class="back" src="../../assets/common_back.png" alt=""
                 @click="registerHaveAccountNumber">
            <span class="title">完善个人信息</span>
        </div>

        <div id="body-bg">
            <div id="body">
                <div style="height: 10px; width: 100%"></div>
                <div id="line">
                    <div id="body-header">
                        <div class="header-icon"> > </div>
                        <span style="color: #ed3f14; margin: 5px">手机号</span>
                    </div>

                    <div id="body-form">
                        <div class="info">
                            <img class="icon"
                                 src="../../assets/member_phone.png" alt="">
                            <input class="input" type="tel" name="memberNumber"
                                   placeholder="手机"
                                   v-model="registerForm.mobile"  maxlength="11">
                        </div>
                        <div class="info" style="margin-top: 20px">
                            <img class="icon" src="../../assets/password.png" alt="">
                            <input class="input" type="password" name="memberNumber" placeholder="请输入会员号密码"
                                   v-model="registerForm.password">
                        </div>
                        <div style="color: red;text-align: left;margin-top: 10px;">备注：注册成功后，密码为手机号。</div>
                    </div>

                    <div id="submit">
                        <button v-if=searchButtonVisible class="submit-btn" @click="login" :disabled="btnDisable">提交</button>
                        <!--<button v-if=loginButtonVisible class="submit-btn" @click="login" :disabled="btnDisable">登录</button>-->
                        <!--<button v-if=submitButtonVisible class="submit-btn" @click="registerSubmit" :disabled="btnDisable">提交注册</button>-->
                    </div>

                </div>
                <div style="height: 10px; width: 100%"></div>
            </div>

            <registry-dialog v-show="registryVisible" :title="title" width="80%" @closeRegisty="closeRegisty" @registerSubmit="registerSubmit">
                <p class="tip">手机号{{registerForm.mobile}}未注册,是否注册为会员?</p>
            </registry-dialog>


            <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
                <p>{{ message }}</p>
            </base-dialog>

            <div class="toast" v-show="toastShow">
                {{toastText}}
            </div>
        </div>

        <div style="height: 10px"></div>
    </div>
</template>

<script>
    import BaseDialog from "../../components/BaseDialog";
    import RegistryDialog from "../../components/RegistryDialog";
    import {GetTelephone} from "@/api/Login";
    export default {
        name: "MemberRegisterSecond",
        components: {BaseDialog,RegistryDialog},
        data() {
            return {
                registerForm: {
                    // username: '',
                    password: '',
                    confirmPassword: '',
                    realName: '',
                    mobile: '',
                    openId: '',
                    unionId: ''
                },
                display: false,
                drawerWidth: '200px',
                searchButtonVisible:true,
                loginButtonVisible:false,
                submitButtonVisible:false,

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                registryVisible: false,
                message: "",

                isSuccess: false,

                btnDisable: false,
            }
        },

        methods: {
            close() {
                this.messageVisible = false;
                this.$emit('close');
                if (this.isSuccess) {
                    this.$router.push({path: '/'});
                }
            },
            closeRegisty(){
                this.registryVisible = false;
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                }, 1500)
            },

            //提交注册
            registerSubmit() {

                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.registerForm.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                this.btnDisable = true;

                this.registerForm.password = this.registerForm.mobile;
                this.$store.dispatch('WeChatRegistry', this.registerForm)
                    .then((response) => {
                    if (response.code === this.$API_CODE.OK) {
                        this.isSuccess = true;
                        this.message = '会员注册成功，会员名：' + response.data.username;
                        this.messageVisible = true;
                        this.btnDisable = false;
                        this.login();
                    }
                }).catch(error=>{
                    this.message = error.message;
                    this.messageVisible = true;
                    this.btnDisable = false;
                })
            },


            //手机号登录
            login() {
                if (this.registerForm.mobile == "") {
                    this.toast("请输入手机号");
                    return
                }

                if (this.registerForm.password == "") {
                    this.toast("请输入密码");
                    return
                }
                console.log(this.registerForm.password);
                // let openId = this.$cookies.get('openid');
                // let unionId = this.$cookies.get('unionid');
                this.registerForm.openId = this.$cookies.get('openid');
                this.registerForm.unionId = this.$cookies.get('unionid');
                this.$store.dispatch('LoginByTelephone', this.registerForm)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.$router.push({path: '/home'});
                            //this.saveAccountInfoToCookie()
                        }else {
                            //this.searchButtonVisible=false;

                            // this.loginButtonVisible=false;
                            // this.submitButtonVisible=true;
                        }
                        if (response.code === 20002) {
                            this.registryVisible=true;
                        } else {
                            this.btnDisable = false;
                        }
                    }).catch(error=>{
                    this.message = error.message;
                    this.messageVisible = true;
                    this.btnDisable = false;
                })
            },

            //查询
            searchTelephone(){
                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.registerForm.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                GetTelephone(this.registerForm.mobile)//如果有code，说明用户点击了授权  将获取到的code传递给后台
                            .then(res => {
                                // 返回状态和UId
                                if (res.code === this.$API_CODE.OK) {
                                    //this.searchButtonVisible=false;
                                    // this.loginButtonVisible=true;
                                    this.submitButtonVisible=false;
                                }else {
                                    this.registryVisible=true;
                                    // this.toast("当前未注册");
                                    // //this.searchButtonVisible=false;
                                    // this.loginButtonVisible=false;
                                    // this.submitButtonVisible=true;
                                }
                            });
            },

            //已有账号和返回
            registerHaveAccountNumber() {
                this.$router.push({path: '/'});
            },

            //限制输入框的内容只能为汉字
            inputChange(e) {
                const o = e.target;
                this.registerForm.realName = o.value.replace(/[^\u4E00-\u9FA5]/g, '');

            },


        }
    }
</script>

<style scoped lang="scss">

    #register-member-second {
        background-color: #f2f2f2;
        position: absolute;
        width: 100%;
        height: 100%;
        //header区域
        #header {
            height: 40px;
            line-height: 40px;
            background-color: #ed3f14;
            font-size: 1rem;

            .back {
                margin-top: 8px;
                line-height: 35px;
                margin-left: 10px;
                float: left;
            }

            .more {
                margin-top: 8px;
                line-height: 35px;
                margin-right: 10px;
                float: right;
            }

            .title {
                color: white;
            }
        }

        //body区域
        #body {
            margin: 30px;
            border-radius: 15px;
            background-color: white;
            clear: both;

            //表单外面的红线
            #line {
                border: 1px solid #ed3f14;
                margin: 10px;
                border-radius: 10px;

                //会员注册表单title
                #body-header {
                    margin-left: 10px;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    position: relative;
                    float: left;
                    font-size: 1rem;

                    .header-icon {
                        background: #ed3f14;
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        color: #FFFFFF;
                        font-weight: bold;
                        border-radius: 90px;
                        float: left;
                    }
                }

                //表单
                #body-form {
                    clear: both;
                    margin-left: 15px;
                    margin-right: 15px;
                    margin-top: 30px;

                    .info {
                        width: auto;
                        height: 45px;
                        border-radius: 5px;
                        border: 2px solid #ed3f14;
                        display: flex;
                        align-items: center;
                        margin-top: 20px;

                    }

                    .icon {
                        width: 16px;
                        height: 16px;
                        float: left;
                        margin-left: 10px;
                    }

                    .input {
                        height: 40px;
                        border: 0;
                        outline: none;
                        margin-left: 10px;
                        font-size: 0.8rem;
                        width: 100%;
                    }

                    .input::-webkit-input-placeholder { /* WebKit browsers */

                        color: #ed3f14;

                    }

                    .tip {
                        color: red;
                        font-size: 0.8rem;
                        text-align: left;
                        margin: 3px;
                    }
                    .tip-cancel {
                        float: left;
                        width: 45%;
                        color: #ffffff;
                        padding: 10px 0;
                        background: #ea2d53;
                        border-radius: 5px;
                    }
                    .tip-ok {
                        width: 45%;
                        float: right;
                        color: #ffffff;
                        padding: 10px 0;
                        background: #ea2d53;
                        border-radius: 5px;
                        border: none;
                    }
                }

                #submit {
                    margin-left: 15px;
                    margin-right: 15px;

                    .submit-btn {
                        width: 100%;
                        /*height: 40px;*/
                        margin-top: 20px;
                        margin-bottom: 10px;
                        border: 0;
                        line-height: 35px;
                        border-radius: 5px;
                        background-color: #ed3f14;
                        color: white;
                        font-size: 1rem;
                    }
                }

                #have-account-number {
                    margin-bottom: 20px;

                    .btn {
                        height: 30px;
                        color: #ed3f14;
                        background: white;
                        margin-bottom: 20px;
                        font-size: 1rem;
                        border-left: 0;
                        border-right: 0;
                        border-top: 0;
                        border-bottom-style: solid;
                        border-bottom-color: #ed3f14;
                    }
                }
            }
        }
    }

</style>